import React from 'react'

export default function Logo({ alwaysShowText = false }) {

    return (
        <>
            <div className='logo' >
                {/* <img src='/assets/images/logo.png' alt='logo' /> */}

                {(alwaysShowText) &&
                    <>
                        <h5 style={{ color: 'white' }}  >Mentr</h5>
                        <h3 style={{ color: 'white' }}  >M</h3>
                    </>
                }
            </div>
        </>
    )
}
